module.exports = __webpack_public_path__ + "media/images/img/tag_company/ns_tag-68c474f43a3d8fe5ad48056cab4eb8d2.png";